export default {
  namespaced: true,
  state: {
    isOffline: false,
    isSyncing: false,
    progressive: 0,
    syncTuples: []
  },
  getters: {
    isOffline: state => {
      return state.isOffline;
    },
    isNotSynchronized: state => {
      if (state.syncTuples.length) {
        return true;
      } else {
        return false;
      }
    },
    // getProgressive: state => {
    //   return state.progressive;
    // },
    isSynchronized: (state) => tupleIdStart => {
      return state.syncTuples.filter(tupleId => tupleId.split('@')[0] === tupleIdStart).length === 0;
    },
    isSyncing: (state) => {
      return state.isSyncing;
    }
  },
  mutations: {
    reset: state => {
      // state.progressive = 0;
      state.syncTuples = [];
    },
    setOfflineMode: (state) => {
      console.log('going offline...');
      if(!state.isOffline) {
        state.isOffline = true;
      }
    },
    setOnlineMode: (state) => {
      state.isOffline = false;
    },
    // incProgressive: (state) => {
    //   state.progressive++;
    // },
    setIsSyncing: (state, val) => {
      state.isSyncing = val;
    },
    addSyncTuple: (state, tupleId) => {
      state.syncTuples.push(tupleId);
    },
    deleteSyncTuple: (state, tupleId) => {
      state.syncTuples.splice(tupleId,1);
    },
    deleteSyncTuples: (state, tupleIdStart) => {
      const newSyncTuples = state.syncTuples.filter(tupleId => tupleId.split('@')[0] !== tupleIdStart);
      state.syncTuples = newSyncTuples;
    }
  },
  actions: {
    reset: ({ commit }) => {
      commit('reset');
    },
    setOfflineMode: ({ commit }) => {
      commit('setOfflineMode');
    },
    setOnlineMode: ({ commit }) => {
      commit('setOnlineMode');
    },
    // incProgressive: ({ commit }) => {
    //   commit('incProgressive');
    // },
    loadSyncTuples: async ({ commit }, vlf) => {
      await vlf.iterate((val, key, index) => {
        // commit('incProgressive');
        commit('addSyncTuple', key);
      });
    },
    /**
     * Use this action to register an offline update of an object. Content of this table will
     * be used to sync data with the server when the app goes back online.
     *
     * {Object} _vue Vue app
     * {String} _class PHP classname the server uses to process this tuple
     * {String} _table Localforage table to update data when processing response
     * {String} mode 'new' / 'edit / 'delete'
     * {String} type 'obj' / 'file'
     * {Object} obj Object modified
     */
    saveSyncTuple: async ({ commit, state }, { _vue, _class, _table, mode, type, obj }) => {
      /* Viene mantenuto nello store il numero di sequenza raggiunto negli update da quando si è passati offline */
      const syncTable = _vue.$vlf("syncUpdates");
      const syncId = obj.dbKey; // can be uuidV4 (new object) or serverId dbKey
      // event creation time - microseconds
      const timestamp = _vue.$moment().valueOf();
      // tupleId to save in local storage
      const tupleId = _vue.$anm22.MD5(_class + syncId) + '@' + timestamp;
      const tuple = {
        version: 3,
        obj: obj,
        class: _class,
        table: _table,
        syncId,
        mode,
        type,
        timestamp
      };
      // }
      /* inserisco la tupla per la sincronizzazione */
      await syncTable.setItem(tupleId, tuple);
      // only hash in memory for check because we only want to check if any tuple for an object is not synced
      commit('addSyncTuple', tupleId);
    },
    removeSyncTuples: async ({ commit, state }, { _vue, _class, syncId }) => {
      const syncTable = _vue.$vlf("syncUpdates");
      const tupleIdStart = _vue.$anm22.MD5(_class + syncId);

      const keys = await syncTable.keysStartingWith(tupleIdStart);
      keys.forEach(key => syncTable.removeItem(key));
      commit('deleteSyncTuples', tupleIdStart);
    },
    removeSyncTuple: async ({ commit, state }, { _vue, _class, syncId, timestamp }) => {
      const syncTable = _vue.$vlf("syncUpdates");
      const tupleId = _vue.$anm22.MD5(_class + syncId) + '@' + timestamp;
      
      /* Elimino la tupla per la sincronizzazione */
      syncTable.removeItem(tupleId);
      commit('deleteSyncTuple', tupleId);
    },
    sync: async ({ commit, state, dispatch }, { _vue, blocking, callback }) => {
      console.log('[offline] syncing!');
      if(blocking) {
        commit('setIsSyncing', true);
      }
      const syncTable = _vue.$vlf('syncUpdates');
      const reqData = [];
      let response = null;
      try {
        await syncTable.iterate((v, k, i) => {
          reqData.push(v);
        });
        if(reqData.length > 0) {
          let formData = new FormData();
          reqData.forEach(d => {
            formData.append('data[]', JSON.stringify(d));
            if(d.type === 'file') {
              formData.append('files['+ d.class + d.syncId +']', d.obj.file);
            }
          })
          response = await _vue.$http.post('sync', formData, {
            withCredentials: true
          });
        } else {
          throw new Error('No data to sync!');
        }
        if(response && response.data) {
          response.data.success.forEach(d => {
            if(d.requestData.mode === 'new' || d.requestData.mode === 'edit'){
              const table = _vue.$vlf(d.requestData.table)
              if(d.responseData) {
                dispatch(d.requestData.table + '/update', {
                  vlf: table, objs: [ d.responseData ]
                }, {root: true});
              }
              // Anche se ho ricevuto false come risposta (quindi non ci sono tuple da aggiornare nel db locale),
              // cancello quella temporanea con id locali. Questo ad esempio viene usato per Food e la queue di stampa comande,
              // non manteniamo la tupla in locale una volta sincronizzata e successivamente quella temporanea viene cancellata
              if(d.requestData.mode === 'new') {
                if(Object.keys(_vue.$store._actions).includes(d.requestData.table + '/delete')) {
                  dispatch(d.requestData.table + '/delete', {
                    vlf: table, obj: d.requestData.obj
                  }, {root: true});
                } else {
                  // in case no module exists
                  table.removeItem(d.requestData.obj.dbKey);
                }
              }
            }
          });
          // clean sync Updates table
          syncTable.clear();
          commit('reset');
          // Restore unresolved tuples with new progressive numbers
          response.data.unresolved
            .sort((a,b) => a.requestData.timestamp - b.requestData.timestamp)
            .forEach(d => {
              const tuple = d.requestData;
              const tupleId = _vue.$anm22.MD5(tuple.class + tuple.syncId) + '@' + tuple.timestamp;
              syncTable.setItem(tupleId, tuple);
              commit('addSyncTuple', tupleId);
            });
          if(callback && typeof callback === 'function') {
            if(blocking) {
              await callback(response.data);
            } else {
              callback(response.data);
            }
          }
        } else {
          throw new Error('Empty response!');
        }
      } catch(e) {
        console.log(e.message);
      } finally {
        commit('setIsSyncing', false);
      }
    }
  }
}
